module.exports = __webpack_public_path__ + "static/media/oil.0a8be1da.jpg";